import { Injectable } from '@angular/core';
import {
  Observable,
  Subject,
  debounceTime,
  map,
  shareReplay,
  switchMap,
} from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { PdEventSearchResponse } from 'src/app/common/types/responses/responses';
import { PdEvent } from '../../dtos/pd.dto';

@Injectable({
  providedIn: 'root',
})
export class PdEventSearchService {
  items: Observable<PdEvent[]>;

  currentResponse: PdEventSearchResponse;

  private term: Subject<string> = new Subject<string>();

  constructor(private apiService: APICoreService) {
    this.items = this.term.pipe(
      debounceTime(250),

      switchMap((term: string) => this.findEvents(term, 10000, 1)),
      shareReplay(1)
    );
  }

  search(term: string) {
    /**
     * Set the value which the search stream will work.
     */
    return this.term.next(term);
  }

  complete(): void {
    this.term.complete();
  }

  public findEvents(
    searchTerm = '',
    per_page = 20,
    page = 1
  ): Observable<PdEvent[]> {
    const params: {
      search?: string;
      page: number;
      per_page: number;
    } = {
      page,
      per_page,
    };

    if (searchTerm) {
      params.search = searchTerm;
    }

    return this.apiService.getRequest('growelab/pd/events', params).pipe(
      map((response) => {
        this.currentResponse = {
          pdEvents: response.items,
          _meta: response._meta,
          _links: response._links,
        };
        return response.items;
      })
    );
  }

  public getAllEvents(): Observable<PdEvent[]> {
    const params: {
      page: number;
      per_page: number;
    } = {
      page: 1,
      per_page: 300,
    };

    return this.apiService.getRequest('growelab/pd/events', params).pipe(
      map((response) => {
        this.currentResponse = {
          pdEvents: response.items,
          _meta: response._meta,
          _links: response._links,
        };
        return response.items;
      })
    );
  }

  getEvent(id: number): Observable<PdEvent | null> {
    return this.apiService
      .getRequest(`growelab/pd/event/${id}`)
      .pipe(map((response) => response.item));
  }
}
